export const ApiEndpoints = {
  branches: "/api/branches",
  districts: "/api/districts",
  registration: "/api/app/registration",
  verifyOtp: "/api/app/verifyOtp",
  login: "/api/app/login",
  matchingProfiles: "/api/app/matchingProfiles",
  findByProfileId: "/api/app/findByProfileId",
  allProfiles: "/api/app/allProfiles",
  selectProfile: "/api/app/selectProfile",
  selectedProfiles: "/api/app/selectedProfiles",
  getDashboardData: "/api/app/getDashboardData",
  myProfile: "/api/app/myProfile",
  getMembershipDetails: "/api/app/getMembershipDetails",
  verifyMobileNumber: "/api/app/verifyMobileNumber",

};
